export default "__VITE_ASSET__4e2c568b__"